var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from '@app/core';
import { finalize } from 'rxjs/operators';
import { LOCAL_VAR } from '@app/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DealHelpComponent } from '@app/shared/modals/deal-help/deal-help.component';
import { DealsService } from '@app/core/service/deals.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
var CustomProductsComponent = /** @class */ (function () {
    function CustomProductsComponent(modalService, router, utilService, authenticationService, formBuilder, toastrService, dealsService) {
        this.modalService = modalService;
        this.router = router;
        this.utilService = utilService;
        this.authenticationService = authenticationService;
        this.formBuilder = formBuilder;
        this.toastrService = toastrService;
        this.dealsService = dealsService;
        this.modalMode = 'create';
        this.editingItemId = null;
        this.loggedInUserType = null;
        this.isLoading = false;
        this.perPage = 10;
        this.sortDir = -1;
        this.currentPage = 1;
        this.sortBy = 'updateTime';
        this.pager = {
            perPage: 10,
            currentPage: 1,
            Totalrecords: 0,
            TotalPages: 0
        };
        this.isProductLoading = false;
        this.productMaster = [];
        this.statusTypes = [
            { text: 'Enabled', value: false },
            { text: 'Disabled', value: true }
        ];
        this.productsCategory = [{ name: 'VSC', slug: 'vsc' }, { name: 'GAP', slug: 'gap' }, { name: 'Theft Protection', slug: 'theft-protection' }, { name: 'Lease Excess Wear and Tear', slug: 'lease-excess-wear-and-tear' }];
        this.currentStatus = '';
        this.environmentUrl = environment.serverUrl;
        this.filterApplied = false;
        this.user = this.authenticationService.credentials.user;
        // console.log(this.user)
        this.loggedInUserType = this.user.userRoleId.slug;
        localStorage.setItem(LOCAL_VAR.selectedAgency, null);
        this.getProductsarray();
        this.createForm();
        this.getListByFilter();
    }
    CustomProductsComponent.prototype.ngOnInit = function () {
    };
    CustomProductsComponent.prototype.createForm = function () {
        this.fiterForm = this.formBuilder.group({
            name: [''],
            category: [''],
            subcategory: [''],
            brand: [''],
            order: [''],
            submittedBy: [''],
            disable: [''],
            sortFieldFilter: ['createdAt'],
            sortByFilter: [-1],
            perPage: 10
        });
        this.customCreateForm = this.formBuilder.group({
            name: ['', Validators.required],
            brand: ['DOWC', Validators.required],
            category: ['servicecontract', Validators.required],
            subcategory: ['', Validators.required],
            order: [1, Validators.required],
            disable: [false]
        });
        // this.categories = this.productsCategory.map((prod) => {
        //   return { name: prod.name, slug: prod.slug, categorySlug: 'servicecontract' };
        // });
        // this.fiterForm.valueChanges.subscribe(values => {
        //   //this.pager.currentPage = 1;
        //   //this.getListByFilter();
        //   const self = this;
        //   clearInterval(self.timer);
        //   self.timer = setInterval(() => {
        //     clearInterval(self.timer);
        //     self.getListByFilter();
        //   }, 500);
        // });
    };
    CustomProductsComponent.prototype.onEnterSearch = function () {
        this.getListByFilter();
    };
    CustomProductsComponent.prototype.getProductName = function (slug) {
        var product = this.productsCategory.find(function (prod) { return prod.slug == slug; });
        return product ? product.name : '';
    };
    CustomProductsComponent.prototype.clearFilters = function () {
        this.fiterForm.controls['name'].setValue('');
        this.fiterForm.controls['brand'].setValue('');
        this.fiterForm.controls['category'].setValue('');
        this.fiterForm.controls['subcategory'].setValue('');
        this.fiterForm.controls['order'].setValue('');
        this.fiterForm.controls['disable'].setValue('');
        this.fiterForm.controls['perPage'].setValue(10);
        // this.fiterForm.controls['sortFieldFilter'].setValue('createdAt');
        this.fiterForm.controls['sortByFilter'].setValue(-1);
        this.sortBy = 'createdAt';
        this.sortDir = -1;
        this.pager.currentPage = 1;
        this.pager.perPage = 10;
        this.getListByFilter();
    };
    CustomProductsComponent.prototype.getListByFilter = function () {
        var payload = this.getPayload();
        this.pager.perPage = payload.perPage;
        delete payload.perPage;
        this.getList(this.pager.currentPage, payload);
    };
    CustomProductsComponent.prototype.getList = function (page, payload) {
        var _this = this;
        payload.currentPage = page;
        payload.perPage = this.pager.perPage;
        this.isLoading = true;
        this.dealsService
            .getCustomProductsList(payload)
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            if (response.records) {
                _this.productList = response.records;
                _this.checkFilterApplied();
                _this.renderPagination(response.page, response.total, response.totalPage);
            }
        }, function (error) {
            console.log('Deal list error:', error);
            _this.isLoading = false;
        });
    };
    CustomProductsComponent.prototype.checkFilterApplied = function () {
        var payload = this.getPayload();
        console.log('payload', payload);
        var applied = false;
        var keys = Object.keys(payload);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== 'perPage' &&
                key !== 'sortFieldFilter' &&
                key !== 'sortByFilter' &&
                key !== 'currentPage') {
                applied = true;
                break;
            }
        }
        this.filterApplied = applied;
    };
    CustomProductsComponent.prototype.sort = function (sortByVal) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.sortBy === sortByVal) {
                    this.sortDir = this.sortDir === 1 ? -1 : 1;
                }
                else {
                    this.sortDir = 1;
                }
                /*  this.sortFieldFilter.setValue(sort);
                this.sortByFilter.setValue(sortDir); */
                this.fiterForm.value.sortFieldFilter = sortByVal;
                this.fiterForm.value.sortByFilter = this.sortDir;
                this.sortBy = sortByVal;
                this.getListByFilter();
                return [2 /*return*/];
            });
        });
    };
    CustomProductsComponent.prototype.goPage = function () {
        var goto = this.nameInput.nativeElement.value;
        this.setPage(goto);
        this.nameInput.nativeElement.value = '';
    };
    CustomProductsComponent.prototype.setPage = function (page) {
        if (0 < page &&
            page <= this.pager.TotalPages &&
            page != this.pager.currentPage) {
            this.pager.currentPage = page;
            this.getListByFilter();
        }
    };
    CustomProductsComponent.prototype.renderPagination = function (page, total, totalPage) {
        this.pager.currentPage = page;
        this.pager.Totalrecords = total;
        this.pager.TotalPages = totalPage;
        this.PageList = this.utilService.getPageList(this.pager.TotalPages, this.pager.currentPage);
    };
    CustomProductsComponent.prototype.onBrandChange = function (selectedBrand) {
        var _this = this;
        // console.log(selectedBrand);
        var products = ['vsc', 'gap', 'theft-protection', 'lease-excess-wear-and-tear'];
        this.categories = [];
        var filtered = this.productMaster.find(function (element) { return element.slug == selectedBrand; });
        console.log(filtered);
        filtered.category.forEach(function (cat) {
            if (cat.product && cat.product.length) {
                cat.product.forEach(function (prod) {
                    if (products.includes(prod.slug)) {
                        _this.categories.push({ name: prod.name, slug: prod.slug, categorySlug: cat.slug });
                    }
                });
            }
        });
        if (this.modalMode === 'create') {
            this.customCreateForm.controls['subcategory'].setValue('');
        }
        console.log(this.categories);
    };
    CustomProductsComponent.prototype.updateCategory = function () {
        var selectedSubcat = this.customCreateForm.get('subcategory').value;
        var selectedCategory = this.categories.find(function (cat) { return cat.slug == selectedSubcat; });
        if (selectedCategory) {
            this.customCreateForm.controls['category'].setValue(selectedCategory.categorySlug);
        }
    };
    CustomProductsComponent.prototype.getProductsarray = function () {
        var _this = this;
        // console.log('arayyyy');
        this.isProductLoading = true;
        this.dealsService
            .getProductsarray('master')
            .pipe(finalize(function () {
            _this.isProductLoading = false;
        }))
            .subscribe(function (response) {
            _this.productMaster = response;
        });
    };
    CustomProductsComponent.prototype.openPop = function (modal, product) {
        if (product) {
            this.editingItemId = product._id;
            this.modalMode = 'Update';
            this.customCreateForm.reset({
                name: product.name,
                brand: product.brand,
                category: product.category,
                subcategory: product.subcategory,
                order: product.order,
                disable: product.disable ? true : false
            });
            if (product.brand)
                this.onBrandChange(product.brand);
        }
        else {
            this.modalMode = 'create';
            this.editingItemId = null;
            this.customCreateForm.reset({
                name: '',
                brand: 'DOWC',
                category: 'servicecontract',
                subcategory: '',
                order: 1,
                disable: false
            });
            this.onBrandChange('DOWC');
        }
        var modalRef = this.modalService.open(modal, { backdrop: 'static' });
        modalRef.result.then(function (result) {
            if (result === 'confirm') {
                // this.confirmChangeStatus(dealId);
            }
        });
    };
    CustomProductsComponent.prototype.openDelete = function (modal, productId) {
        var _this = this;
        var modalRef = this.modalService.open(modal, { backdrop: 'static' });
        modalRef.result.then(function (result) {
            if (result === 'confirm') {
                _this.dealsService
                    .removeCustomProduct(productId)
                    .pipe(finalize(function () {
                    _this.isLoading = false;
                }))
                    .subscribe(function (response) {
                    _this.toastrService.info('Custom product deleted successfully.');
                    // this.modalRef.close();  
                    // this.getListByFilter();
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                }, function (error) {
                    console.log('Confirmation modal error:', error.error.validation.errors);
                    _this.isLoading = false;
                });
            }
        });
    };
    CustomProductsComponent.prototype.submitGroup = function () {
        var _this = this;
        if (this.customCreateForm.invalid) {
            for (var i in this.customCreateForm.controls) {
                console.log(i, this.customCreateForm.controls[i].value, this.customCreateForm.controls[i].invalid);
                this.customCreateForm.controls[i].markAsTouched();
            }
            return;
        }
        var payload = this.customCreateForm.value;
        payload.slug = this.utilService.convertSlug(payload.name);
        this.isLoading = true;
        this.dealsService
            .submitCustomProduct(this.customCreateForm.value, this.editingItemId)
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            _this.toastrService.info('Custom product submitted successfully.');
            // this.getListByFilter();
            // if (this.modalRef) {
            //   this.modalRef.close('success'); // or dismiss()
            //   this.modalRef = null;
            // }
            setTimeout(function () {
                window.location.reload();
            }, 1000);
        }, function (error) {
            console.log('Confirmation modal error:', error.error.validation.errors);
            _this.isLoading = false;
        });
    };
    CustomProductsComponent.prototype.getPayload = function () {
        var payload = JSON.parse(JSON.stringify(this.fiterForm.value));
        payload = this.utilService.removeEmpty(payload);
        return payload;
    };
    CustomProductsComponent.prototype.exportProducts = function () {
        var _this = this;
        var payload = this.getPayload();
        this.isLoading = true;
        this.dealsService
            .getCustomProductsExport({})
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            if (response.data) {
                _this.downloadFile(response.data);
            }
        });
    };
    CustomProductsComponent.prototype.downloadFile = function (data) {
        var aTag = document.createElement('a');
        document.body.appendChild(aTag);
        aTag.style.display = 'none';
        var url = this.environmentUrl.slice(0, -3) + '/' + data;
        aTag.href = url;
        aTag.setAttribute('target', '_blank');
        aTag.click();
        document.body.removeChild(aTag);
    };
    CustomProductsComponent.prototype.omit_special_char = function (event) {
        var k;
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) ||
            (k > 96 && k <= 122) ||
            k == 8 ||
            k == 32 ||
            (k >= 48 && k <= 57));
    };
    CustomProductsComponent.prototype.omit_special_Mailchar = function (event) {
        var k;
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) ||
            (k > 96 && k <= 122) ||
            k === 46 ||
            k === 64 ||
            k == 8 ||
            k == 32 ||
            (k >= 48 && k <= 57));
    };
    CustomProductsComponent.prototype.openHelpPopup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalService.open(DealHelpComponent)];
                    case 1:
                        modalRef = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CustomProductsComponent;
}());
export { CustomProductsComponent };
